import React from 'react';
import {
  useParams,
} from 'react-router';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import {
  Chat,
  Conversations,
} from 'web-components';

import * as S from './styled';

const ProMessages = () => {
  const { id, category } = useParams();

  return (
    <S.Wrapper>
      <Conversations
        id={id}
      />
      {id ? (
        <Chat
          id={id}
          category={category || '1'}
        />
      ) : (
        <Flex
          fillSpace
          column
          align="center"
          justify="center"
          spacing={10}
        >
          <SVG.Envelope
            width="100"
            height="75"
          />
          <Text
            color="#cacacb"
          >
            Select an existing conversation or click Add Conversation to start a new one
          </Text>
        </Flex>
      )}
    </S.Wrapper>
  );
};

export default ProMessages;
